export default __webpack_public_path__ + "static/media/school.c1f9d0d1.svg";